module.exports = __webpack_public_path__ + "static/fall-leaves-zoom-36967c4b60ac288a34f3795054400245.jpg";